<script>
import { mapActions } from 'vuex';
import request from '@/services/request';

export default {
    components: {
    },
    data() {
        return {
            delivery: {
                id: '',
                file: '',
            },
            nameFile: '',
            errors: {},
            send: false,
        }
    },
    methods: {
        async saveAsFile(event) {
            const file = event.target.files[0];
            // Validar si hay archivo
            if (!file) {
                return;
            }
            // Validar tipo
            const allowedTypes = ['application/pdf', 'image/jpeg'];
            if (!allowedTypes.includes(file.type)) {
                this.$swal({
                    title: 'No se puede cargar el archivo',
                    text: 'Solo se permiten archivos PDF o JPG.',
                    icon: 'warning',
                });
                this.delivery.file = ''; // Limpia si era inválido
                return;
            }
            // Si es válido, guardarlo
            this.delivery.file = file;
            this.nameFile = file.name;
        },
        async closeModal() {
            this.delivery.id = '';
            this.delivery.file = '';
            this.$modal.hide('completeDelivery');
        },
        async saveForm() {
            let form = this.delivery;
            let _endpoint = '/checks_complete_delivery';
            this.send = true;
            try {
                let { data } = await request.postMedia(_endpoint, form)
                if (data) {
                    console.log(data);
                    this.successNotification(data.message);
                    this.closeModal();                    
                    Event.$emit('event-load-checks');
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
                this.send = false;
            }
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-completeDelivery", async (id) => {
            this.delivery.id = id;
            this.$modal.show('completeDelivery');
        });
    }
}
</script>
<template>
    <modal name="completeDelivery" :width="'500px'" :height="'auto'">
        <div class="modal-body text-center p-5">
            <div class="row">
                <div class="col-md-12">
                    <i class="fas fa-shipping-fast fa-4x text-info icon-modal"></i>
                    <h1>Entrega completa</h1>
                    <h4>Se aprobara la entrega</h4>
                </div>
                <div class="col-md-12 mt-4">
                    <label>Comprobante de entrega</label>
                </div>
                <div class="col-md-12">
                    <input type="file" id="file" ref="file" class="inputfile pt-4" accept=".pdf,.jpg,.jpeg"
                        @change="saveAsFile($event)">
                    <label for="file"><i class="fas fa-upload"></i><br>
                        <span v-if="delivery.file != ''">{{ nameFile }}</span>
                        <span v-else>Selecciona el archivo</span>
                    </label>
                    <div v-if="errors && errors.file" class="text-danger">{{ errors.file[0] }}</div>

                </div>
                <div class="col-md-12">
                    <hr>
                    <div class="row">
                        <div class="col-6 text-left">
                            <button type="button" class="btn btn-outline-secondary btn-lg" @click="closeModal()">
                                <i class="fa fa-undo-alt"></i> Regresar
                            </button>
                        </div>
                        <div class="col-6 text-right">
                            <button :disabled="send" type="button" class="btn btn-outline-success btn-lg"
                                @click="saveForm()">
                                <span v-if="send">
                                    <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                                </span>
                                <span v-else>
                                    <i class="fas fa-save"></i> Guardar
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<style scoped>
.icon-modal {
    border: 1px solid;
    padding: 15px;
    border-radius: 50%;
}

.inputfile+label {
    border-radius: 10px;
}
</style>
